
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://suymhzelfloeclbfsvtp.supabase.co';
const supabaseKey = 'sb_publishable_Xe6iuYC7FnZiBsH0t2ewyA_3UM7sbgG';

export const supabase = createClient(supabaseUrl, supabaseKey);
